import {
    alpha,
    Box,
    CircularProgress,
    CircularProgressProps,
    IconButton,
    Stack,
    Step,
    StepLabel,
    Stepper,
    styled,
} from "@mui/material";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";

export const CustomStepperWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        position: "relative",
    }),
);

export const CustomStepperOverLayBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: alpha(theme.palette.common.black, 0.2),
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
);

export const CustomStepperHeaderStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        py: theme.spacing(4),
        px: theme.spacing(3),
    }),
);

export const CustomStepperHeaderIconButton = styled(
    IconButton,
    styledOmitPropsOptions,
)<{ $hidden?: boolean }>(({ theme, $hidden }) =>
    theme.unstable_sx({
        color: theme.palette.primary.main,
        "& .MuiSvgIcon-root": {
            width: "2rem",
            height: "2rem",
        },
        visibility: () => ($hidden ? "hidden" : "visible"),
    }),
);

export const CustomStepperStepperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        boxShadow: `0 4px 8px 0 ${alpha(theme.palette.common.black, 0.1)}`,
        zIndex: 1,
        py: theme.spacing(3),
        px: theme.spacing(4),
    }),
);

export const CustomStepperStepperStepLabel = styled(StepLabel)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(0),
            width: 12,
            height: 12,
            borderRadius: "100%",
            border: `2px solid ${theme.palette.grey[300]}`,
            "&.Mui-active, &.Mui-completed": {
                backgroundColor: theme.palette.primary.main,
                border: `2px solid ${theme.palette.primary.main}`,
            },
        },
    }),
);

export const CustomStepperStepper = styled(Stepper)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiStepConnector-root": {
            "&.Mui-disabled .MuiStepConnector-line": {
                borderColor: theme.palette.grey[300],
            },
        },
        "& .MuiStepConnector-line": {
            borderColor: theme.palette.primary.main,
            borderTopWidth: 2,
        },
        "&::before": {
            content: `""`,
            display: "flex",
            flex: "1 1 auto",
            height: "2px",
            backgroundColor: theme.palette.primary.main,
        },
        "&::after": {
            content: `""`,
            display: "flex",
            flex: "1 1 auto",
            height: "2px",
            backgroundColor: theme.palette.grey[300],
        },
        "&.last-step::after": {
            backgroundColor: theme.palette.primary.main,
        },
    }),
);

export const CustomStepperStepperStep = styled(Step)(({ theme }) =>
    theme.unstable_sx({
        p: theme.spacing(0),
    }),
);

export const CustomStepperActiveStepContentBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        overflowY: "auto",
        p: theme.spacing(4),
    }),
);

export const CustomStepperBottomControlStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        boxShadow: `0 -4px 8px 0 ${alpha(theme.palette.common.black, 0.1)}`,
        p: theme.spacing(4),
    }),
);

const smallCircularProgressSizePixels = 20;
export const SmallCircularProgress = styled((props: Omit<CircularProgressProps, "size">) => {
    return <CircularProgress {...props} size={smallCircularProgressSizePixels} />;
})(() => ({}));
